import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../icon/icon.module';
import { NavToggleComponent } from './nav-toggle.component';

@NgModule({
  declarations: [NavToggleComponent],
  imports: [CommonModule, IconModule],
  exports: [NavToggleComponent],
})
export class NavToggleModule {}
